import { getSysControlParam } from '../../../../../../api/register/vehicle.js'

export const uploadList = [
    {
        show: true,
        exampleShow: true,
        examplePicWidth: '530px',
        examplePicHeight: '185px',
        dateShow: true,
        example: 'drivingLicense.jpg',
        label: '行驶证正副面',
        placeholder: '请选择行驶证有效期',
        fileName: 'carDrivingFileName',
        fileUrl: 'carDrivingFileUrl',
        fileTemUrl: 'carDrivingFileTemUrl',
        fileId: 'carDrivingFileId',
        endTime: 'carDrivingEndTime',
        isRequired: true
    },
    {
        show: true,
        exampleShow: true,
        examplePicWidth: '530px',
        examplePicHeight: '185px',
        dateShow: false,
        example: 'carDrivingBottom.jpg',
        label: '行驶证背面年审页',
        placeholder: '',
        fileName: 'carDrivingBottomFileName',
        fileUrl: 'carDrivingBottomFileUrl',
        fileTemUrl: 'carDrivingBottomFileTemUrl',
        fileId: 'carDrivingBottomFileId',
        endTime: '',
        isRequired: true
    },
    {
        show: true,
        exampleShow: true,
        examplePicWidth: '350px',
        examplePicHeight: '230px',
        dateShow: true,
        example: 'transportCertificate.jpg',
        label: '道路运输证',
        placeholder: '请选择道路运输证有效期',
        fileName: 'roadTransportFileName',
        fileUrl: 'roadTransportFileUrl',
        fileTemUrl: 'roadTransportFileTemUrl',
        fileId: 'roadTransportFileId',
        endTime: 'roadTransportEndTime',
        isRequired: false
    },
    {
        show: true,
        exampleShow: false,
        examplePicWidth: '450px',
        examplePicHeight: '600px',
        dateShow: true,
        label: '合作/租赁协议',
        example: 'affiliated.jpg',
        placeholder: '请选择挂靠证件有效期',
        fileName: 'affiliatedFileName',
        fileUrl: 'affiliatedFileUrl',
        fileTemUrl: 'affiliatedFileTemUrl',
        fileId: 'affiliatedFileId',
        endTime: 'affiliatedEndTime',
        isRequired: false,
        hasTemp: true,
        tempRequest: getSysControlParam,
    },
    {
        show: true,
        exampleShow: false,
        examplePicWidth: '300px',
        examplePicHeight: '200px',
        dateShow: false,
        label: '车辆照片',
        example: 'photosVehicle.jpg',
        // placeholder: '请选择挂靠证件有效期',
        fileName: 'photosVehicleFileName',
        fileUrl: 'photosVehicleFileUrl',
        fileTemUrl: 'photosVehicleFileTemUrl',
        fileId: 'photosVehicleFileId'
        // endTime: 'clzpEndTime'
    },
    {
        show: true,
        exampleShow: false,
        examplePicWidth: '430px',
        examplePicHeight: '600px',
        dateShow: true,
        label: '交强险',
        example: 'trafficInsurance.jpg',
        placeholder: '请选择交强险有效期',
        fileName: 'trafficInsuranceFileName',
        fileUrl: 'trafficInsuranceFileUrl',
        fileTemUrl: 'trafficInsuranceFileTemUrl',
        fileId: 'trafficInsuranceFileId',
        endTime: 'trafficInsuranceEndTime'
    },
    {
        show: true,
        exampleShow: false,
        examplePicWidth: '430px',
        examplePicHeight: '600px',
        dateShow: true,
        label: '商业保险',
        example: 'businessInsurance.jpg',
        placeholder: '请选择商业保险有效期',
        fileName: 'businessInsuranceFileName',
        fileUrl: 'businessInsuranceFileUrl',
        fileTemUrl: 'businessInsuranceFileTemUrl',
        fileId: 'businessInsuranceFileId',
        endTime: 'businessInsuranceEndTime'
    },
    {
        // show: true,
        // exampleShow: false,
        // examplePicWidth: '430px',
        // examplePicHeight: '600px',
        // dateShow: true,
        label: '挂车行驶证正副页',
        // example: 'trailerDriving.jpg',
        // placeholder: '请选择挂车行驶证正副页',
        fileName: 'trailerDrivingFileName',
        fileUrl: 'trailerDrivingFileUrl',
        fileTemUrl: 'trailerDrivingFileTemUrl',
        fileId: 'trailerDrivingFileId',
    },
    {
        // show: true,
        // exampleShow: false,
        // examplePicWidth: '430px',
        // examplePicHeight: '600px',
        // dateShow: true,
        label: '挂车行驶证年审页',
        // example: 'trailerDrivingVerify.jpg',
        // placeholder: '请选择挂车行驶证年审页',
        fileName: 'trailerDrivingVerifyFileName',
        fileUrl: 'trailerDrivingVerifyFileUrl',
        fileTemUrl: 'trailerDrivingVerifyFileTemUrl',
        fileId: 'trailerDrivingVerifyFileId',
    },
];
